export default function setLocalStorage(key, value, expirationms) {
  const now = new Date();
  const item = {
    value: value,
    expiry: now.getTime() + expirationms, // ttl in milliseconds
  };
  localStorage.setItem(key, JSON.stringify(item));
}
